module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"upgradeSuccess":"Plan upgraded","downgradeSuccess":"Your plan will change to “{plan}” on {date}","renewSuccess":"Subscription renewed","paymentSuccess":"Payment was successful","prolongSuccess":"Subscription prolongation was successful"}}')
  delete Component.options._Ctor
}
